import { Typography } from '@material-ui/core';
import { useStyles } from "./triptychItemStyles";

export interface TriptychItemModel {
  image: string;
  header: string;
  text: string;
}

function TriptychItem({
  image, 
  text, 
  header
}: TriptychItemModel) {
  const styles = useStyles();
  return (
    <div className={styles.triptychItemWrapper}>
      <img className={styles.triptychItemImage} src={image} alt='Triptych Item'/>
      <Typography variant="body2" color="inherit" style={{
        color: "#0455a4",
        fontSize: "17px",
        fontWeight: 600,
        marginTop: '25px'
      }} paragraph> 
        {header.toUpperCase()}
      </Typography>
      <Typography className={styles.triptychItemText} variant="body2" color="inherit" paragraph>
        {text}
      </Typography>
    </div>
  )
}

export default TriptychItem
